import {get, writable} from 'svelte/store';

import {STATISTICS}         from '../../constants/statistics';
import {filterKarts}        from '../../services/filter-karts';
import {scoresStore}        from '../filters/scores-store';
import {results1BuiltStore} from './results-1-built-store';

const createStore = () => {
  // Using derived() with results1BuiltStore and scoresStore as dependencies
  // triggers redundant recalculations when multiple stores change (ex. when a Quick
  // Pick is selected). Instead, use subscribe() and freeze/unfreeze this store's
  // value explicitly.
  const {subscribe, set} = writable(calculate());

  let frozen = true;

  function calculate() {
    const results1Built = get(results1BuiltStore);
    const scores = get(scoresStore);
    const karts = filterKarts(results1Built.karts, scores);

    return {
      counts: {
        ...results1Built.counts,
        filtered: karts.length
      },
      karts,
      maxScores: calculateMaxScores(karts)
    };
  }

  const refresh = () => { set(calculate()); };
  const freeze = () => { frozen = true; };
  const unfreeze = () => { frozen = false; };

  results1BuiltStore.subscribe(() => { if (!frozen) refresh(); });
  scoresStore.subscribe(() => { if (!frozen) refresh(); });

  unfreeze();

  return {subscribe, freeze, unfreeze};
};

const calculateMaxScores = (karts) => {
  const result = [];

  STATISTICS.forEach(() => {
    result.push(0);
  });

  karts.forEach((kart) => {
    STATISTICS.forEach((_, index) => {
      if (kart.stats[index] > result[index]) {
        result[index] = kart.stats[index];
      }
    })
  });

  return result;
};

export const results2FilteredStore = createStore();
